export default __webpack_public_path__ + "static/media/user.bdcbed10.png";